// Global polyfills for HoloLens EdgeHTML v18 compatibility
// This file must be plain JavaScript (not TypeScript) and loaded FIRST

// Polyfill for globalThis (ES2020)
(function() {
  if (typeof globalThis === 'undefined') {
    window.globalThis = window;
  }
})();

// Polyfill for Array.prototype.flat (ES2019)
if (!Array.prototype.flat) {
  Array.prototype.flat = function(depth) {
    var flattend = [];
    (function flat(array, depth) {
      for (var el of array) {
        if (Array.isArray(el) && depth > 0) {
          flat(el, depth - 1);
        } else {
          flattend.push(el);
        }
      }
    })(this, Math.floor(depth) || 1);
    return flattend;
  };
}

// Polyfill for Array.prototype.flatMap (ES2019)
if (!Array.prototype.flatMap) {
  Array.prototype.flatMap = function(callback, thisArg) {
    return this.map(callback, thisArg).flat(1);
  };
}

// Polyfill for Object.fromEntries (ES2019)
if (!Object.fromEntries) {
  Object.fromEntries = function(entries) {
    if (!entries || !entries[Symbol.iterator]) {
      throw new Error('Object.fromEntries() requires a single iterable argument');
    }
    var obj = {};
    for (var pair of entries) {
      if (Object(pair) !== pair) {
        throw new TypeError('iterable for fromEntries should yield objects');
      }
      var key = pair[0];
      var val = pair[1];
      obj[key] = val;
    }
    return obj;
  };
}

// Polyfill for String.prototype.matchAll (ES2020)
if (!String.prototype.matchAll) {
  String.prototype.matchAll = function(regexp) {
    var flags = regexp.global ? regexp.flags : regexp.flags + 'g';
    var re = new RegExp(regexp, flags);
    var str = this;
    var match;
    var matches = [];
    while ((match = re.exec(str)) !== null) {
      matches.push(match);
    }
    return matches[Symbol.iterator]();
  };
}

// Polyfill for Promise.allSettled (ES2020)
if (!Promise.allSettled) {
  Promise.allSettled = function(promises) {
    return Promise.all(promises.map(function(p) {
      return Promise.resolve(p).then(
        function(value) {
          return { status: 'fulfilled', value: value };
        },
        function(reason) {
          return { status: 'rejected', reason: reason };
        }
      );
    }));
  };
}

// Polyfill for Promise.any (ES2021)
if (!Promise.any) {
  Promise.any = function(promises) {
    return new Promise(function(resolve, reject) {
      var errors = [];
      var rejectedCount = 0;
      var len = promises.length;
      
      if (len === 0) {
        reject(new AggregateError([], 'All promises were rejected'));
        return;
      }
      
      promises.forEach(function(promise, index) {
        Promise.resolve(promise).then(resolve, function(error) {
          errors[index] = error;
          rejectedCount++;
          if (rejectedCount === len) {
            reject(new AggregateError(errors, 'All promises were rejected'));
          }
        });
      });
    });
  };
}

// Polyfill for String.prototype.replaceAll (ES2021)
if (!String.prototype.replaceAll) {
  String.prototype.replaceAll = function(str, newStr) {
    if (Object.prototype.toString.call(str).toLowerCase() === '[object regexp]') {
      return this.replace(str, newStr);
    }
    return this.replace(new RegExp(str, 'g'), newStr);
  };
}

// Polyfill for Array.from (ES2015) - needed for EdgeHTML
if (!Array.from) {
  Array.from = (function () {
    var toStr = Object.prototype.toString;
    var isCallable = function (fn) {
      return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
    };
    var toInteger = function (value) {
      var number = Number(value);
      if (isNaN(number)) { return 0; }
      if (number === 0 || !isFinite(number)) { return number; }
      return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
    };
    var maxSafeInteger = Math.pow(2, 53) - 1;
    var toLength = function (value) {
      var len = toInteger(value);
      return Math.min(Math.max(len, 0), maxSafeInteger);
    };

    return function from(arrayLike/*, mapFn, thisArg */) {
      var C = this;
      var items = Object(arrayLike);
      if (arrayLike == null) {
        throw new TypeError('Array.from requires an array-like object - not null or undefined');
      }
      var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
      var T;
      if (typeof mapFn !== 'undefined') {
        if (!isCallable(mapFn)) {
          throw new TypeError('Array.from: when provided, the second argument must be a function');
        }
        if (arguments.length > 2) {
          T = arguments[2];
        }
      }
      var len = toLength(items.length);
      var A = isCallable(C) ? Object(new C(len)) : new Array(len);
      var k = 0;
      var kValue;
      while (k < len) {
        kValue = items[k];
        if (mapFn) {
          A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
        } else {
          A[k] = kValue;
        }
        k += 1;
      }
      A.length = len;
      return A;
    };
  }());
}

// Polyfill for Object.entries (ES2017)
if (!Object.entries) {
  Object.entries = function(obj) {
    var ownProps = Object.keys(obj);
    var i = ownProps.length;
    var resArray = new Array(i);
    while (i--) {
      resArray[i] = [ownProps[i], obj[ownProps[i]]];
    }
    return resArray;
  };
}

// Polyfill for Object.values (ES2017)
if (!Object.values) {
  Object.values = function(obj) {
    var res = [];
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        res.push(obj[key]);
      }
    }
    return res;
  };
}

// Polyfill for String.prototype.padStart (ES2017)
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length >= targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return padString.slice(0, targetLength) + String(this);
    }
  };
}

// Polyfill for String.prototype.padEnd (ES2017)
if (!String.prototype.padEnd) {
  String.prototype.padEnd = function padEnd(targetLength, padString) {
    targetLength = targetLength >> 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (this.length >= targetLength) {
      return String(this);
    } else {
      targetLength = targetLength - this.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length);
      }
      return String(this) + padString.slice(0, targetLength);
    }
  };
}

// Polyfill for Object.assign (ES2015)
if (!Object.assign) {
  Object.assign = function(target) {
    if (target == null) {
      throw new TypeError('Cannot convert undefined or null to object');
    }
    var to = Object(target);
    for (var index = 1; index < arguments.length; index++) {
      var nextSource = arguments[index];
      if (nextSource != null) {
        for (var nextKey in nextSource) {
          if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
    return to;
  };
}

// Polyfill for queueMicrotask (needed for modern async operations)
if (typeof queueMicrotask === 'undefined') {
  window.queueMicrotask = function(callback) {
    Promise.resolve()
      .then(callback)
      .catch(function(error) {
        setTimeout(function() {
          throw error;
        });
      });
  };
}

// Polyfill for AggregateError (ES2021) - needed for Promise.any
if (typeof AggregateError === 'undefined') {
  window.AggregateError = function AggregateError(errors, message) {
    var instance = new Error(message);
    instance.name = 'AggregateError';
    instance.errors = errors;
    if (Error.captureStackTrace) {
      Error.captureStackTrace(instance, AggregateError);
    }
    return instance;
  };
  window.AggregateError.prototype = Object.create(Error.prototype);
  window.AggregateError.prototype.constructor = window.AggregateError;
}

// Polyfill for Element.prototype.replaceChildren (useful for modern DOM operations)
if (!Element.prototype.replaceChildren) {
  Element.prototype.replaceChildren = function() {
    while (this.lastChild) {
      this.removeChild(this.lastChild);
    }
    if (arguments.length > 0) {
      for (var i = 0; i < arguments.length; i++) {
        this.appendChild(arguments[i]);
      }
    }
  };
}

// Polyfill for String.prototype.trimStart (ES2019)
if (!String.prototype.trimStart) {
  String.prototype.trimStart = function() {
    return this.replace(/^\s+/, '');
  };
}

// Polyfill for String.prototype.trimEnd (ES2019)
if (!String.prototype.trimEnd) {
  String.prototype.trimEnd = function() {
    return this.replace(/\s+$/, '');
  };
}

// Polyfill for Array.prototype.includes (ES2016)
if (!Array.prototype.includes) {
  Array.prototype.includes = function(searchElement, fromIndex) {
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }
    var o = Object(this);
    var len = o.length >>> 0;
    if (len === 0) {
      return false;
    }
    var n = fromIndex | 0;
    var k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);
    while (k < len) {
      if (o[k] === searchElement) {
        return true;
      }
      k++;
    }
    return false;
  };
}

// Polyfill for String.prototype.includes (ES2015)
if (!String.prototype.includes) {
  String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') {
      start = 0;
    }
    if (start + search.length > this.length) {
      return false;
    } else {
      return this.indexOf(search, start) !== -1;
    }
  };
}

// Polyfill for String.prototype.startsWith (ES2015)
if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(search, pos) {
    pos = !pos || pos < 0 ? 0 : +pos;
    return this.substring(pos, pos + search.length) === search;
  };
}

// Polyfill for String.prototype.endsWith (ES2015)
if (!String.prototype.endsWith) {
  String.prototype.endsWith = function(search, this_len) {
    if (this_len === undefined || this_len > this.length) {
      this_len = this.length;
    }
    return this.substring(this_len - search.length, this_len) === search;
  };
}

// Polyfill for String.prototype.repeat (ES2015)
if (!String.prototype.repeat) {
  String.prototype.repeat = function(count) {
    if (this == null) {
      throw new TypeError("can't convert " + this + ' to object');
    }
    var str = '' + this;
    count = +count;
    if (count != count) {
      count = 0;
    }
    if (count < 0) {
      throw new RangeError('repeat count must be non-negative');
    }
    if (count == Infinity) {
      throw new RangeError('repeat count must be less than infinity');
    }
    count = Math.floor(count);
    if (str.length == 0 || count == 0) {
      return '';
    }
    if (str.length * count >= 1 << 28) {
      throw new RangeError('repeat count must not overflow maximum string size');
    }
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while (count) {
      str += str;
      count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
  };
}
